import React, { Fragment, useRef } from 'react';
import { translate } from '../../Services/translation';

const RutabDesktopNavigationItem = ({ links = [], contentLink = null, level = 0, languageSelector = null }) => {
    const menuRef = useRef(null);

    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : null;
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = (link) =>
        link.name || (link.links || []).length > 0;
    const isExtraInfo = (link) => 
        link.extraInfo;

    const toggleSubItems = (e) => {
        e.preventDefault();

        if (e.currentTarget.classList.contains('activeMenuTab')) {
            e.currentTarget.classList.toggle('activeMenuTab');
            menuRef.current.classList.toggle('rutabDesktopNavbar__menu--show');
            return;
        }

        Array.from(e.currentTarget.parentElement.parentElement.querySelectorAll('.activeMenuTab'))
            .forEach((element, index) => {
                element.classList.remove('activeMenuTab');
            });

        e.currentTarget.classList.add('activeMenuTab');

        Array.from(e.currentTarget.parentElement.parentElement.querySelectorAll('.rutabDesktopNavbar__menu--show'))
            .forEach((element, index) => {
                element.classList.remove('rutabDesktopNavbar__menu--show');
            });

        menuRef.current.classList.toggle('rutabDesktopNavbar__menu--show')
    };

    const renderContent = () => {
        if (contentLink.extraInfo) {            
            return <div dangerouslySetInnerHTML={{ __html: contentLink.extraInfo }} />
        }

        if (!hasChildrenClass) {
            return <a className={`rutabDesktopNavbar__link ${hasChildrenClass || ''
                } ${additionClass || ''}`}
                href={contentLink.url || '#'}
                dangerouslySetInnerHTML={{ __html: contentLink.name }}
            ></a>;
        }

        return <a className={`rutabDesktopNavbar__link ${hasChildrenClass || ''
            } ${additionClass || ''}`}
            href={'#'}
            onClick={toggleSubItems}
            dangerouslySetInnerHTML={{ __html: contentLink.name }}
        ></a>;
    }

    const renderChild = (link, index) => {
        if (hasNameOrChildren(link)){ 
            if (isExtraInfo(link)){
                return <div className='extraInfo' key={index}>
                    <RutabDesktopNavigationItem
                        links={link.links}
                        contentLink={link}                                                                    
                    />
                </div>
            } 

            return <li
                className="rutabDesktopNavbar__item"
                key={index}
            >
                <RutabDesktopNavigationItem
                    links={link.links}
                    contentLink={link}                                                
                />
            </li>
        }       
    }

    return (
        <Fragment>
            {!contentLink ? (
                <a
                    className="rutabDesktopNavbar__link--block rutabDesktopNavbar__icon--menu rutabDesktopNavbar__icon"
                    onClick={toggleSubItems}
                    rel="nofollow"
                    href="#"
                    title={translate('general.menu') || 'menu'}
                ></a>
            ) : (
                <Fragment>
                    {renderContent()}
                    {links.length > 0 && (
                        <i
                            className="rutabDesktopNavbar__icon--caret-right rutabDesktopNavbar__icon rutabDesktopNavbar__icon--open"
                            onClick={toggleSubItems}
                        ></i>
                    )}
                </Fragment>
            )}

            {links.length > 0 && (
                <div className="rutabDesktopNavbar__menu" ref={menuRef}>
                    <ul
                        className={"rutabDesktopNavbar__menu-links level" + level}
                        id={contentLink?.name ?? ""}
                    >
                        {links.length > 0 &&
                            links.map(
                                (link, index) =>
                                    renderChild(link,index)             
                            )}
                    </ul>

                    {languageSelector && (
                        <div className='flag-nav-menu' dangerouslySetInnerHTML={{ __html: languageSelector }} />
                    )}                    
                </div>
            )}  
        </Fragment>
    );
};

export default RutabDesktopNavigationItem;
